/**
 * Paket ve cerceve modulleri sepete birden fazla satir ekler.
 * Basarili eklemeden sonra sepet sayfasina gitmek yerine cekmeceyi acar.
 */
(function () {
  function cartElement() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  window.triodCartAddBody = function (items) {
    const cart = cartElement();
    const body = { items: items };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart
        .getSectionsToRender()
        .map(function (section) {
          return section.id;
        })
        .join(',');
      body.sections_url = window.location.pathname;
    }
    return body;
  };

  window.triodOpenCart = function (data) {
    const cart = cartElement();
    const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    if (!cart || !data || !data.sections || typeof cart.renderContents !== 'function') {
      window.location.href = cartUrl;
      return;
    }
    try {
      if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      cart.renderContents(data);
    } catch (error) {
      window.location.href = cartUrl;
    }
  };
})();
